module.exports = __webpack_public_path__ + "static/media/quote_icon.9ac51c53.svg";